import React, { useEffect, useState } from "react";
import {
  AuthStepsHeading,
  AuthStepsParagraph,
  ButtonWithoutIcon,
  OrBetweenButtons,
} from "../../../constents/components";
import Email from "../Email";
import Password from "../Password";
import { useNavigate } from "react-router-dom";
// import useRegister from '../../../Hooks/Registration/useRegister';
import useRegistOtpSender from "../../../Hooks/Registration/useRegistOtpSender";
import useGoogleLogin from "../../../Hooks/Auth/useGoogleLogin";
import { MINIMUM_PASSWORD_LENGTH } from "../../../constents/numbers";
import googleIcon from "../../../Assets/SocialIcons/googleIcon.svg";
import { useDispatch } from "react-redux";
import { updateCurrentRegistrationStep } from "../../../Store/Slices/registrationStates";

const RegistorMain = ({
  updatePassword,
  updateEmail,
  details,
  sendToNextStep,
}) => {
  const heading = "Create Your Account Now";
  const paragraph = "Begin your journey Towards landing your dream job!";
  const signUpWithGoogle = useGoogleLogin();

  const [isEmailValid, setEmailValid] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [loading, error, otpSender] = useRegistOtpSender(sendToNextStep);
  const [localError, setLocalError] = useState("");

  const Navigate = useNavigate();

  useEffect(() => {
    if (!details?.email) {
      setEmailValid(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailValid(emailRegex.test(details.email));
  }, [details?.email]);

  const signInClick = () => {
    if (!details?.email) {
      setLocalError("Email is required");
      return;
    }

    if (!isEmailValid) {
      setLocalError("Please enter a valid email address");
      return;
    }

    if (!details?.password) {
      setLocalError("Password can't be empty");
      return;
    }

    if (details.password.length < MINIMUM_PASSWORD_LENGTH) {
      setLocalError(
        `Password should be at least ${MINIMUM_PASSWORD_LENGTH} characters`,
      );
      return;
    }

    setLocalError("");
    otpSender(details.email);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateCurrentRegistrationStep("onboarding_one"));
  }, [window.location.search]);
  return (
    <>
      <AuthStepsHeading text={heading} />
      <AuthStepsParagraph text={paragraph} />

      <div className=" flex flex-col gap-4 my-4 w-full">
        <Email
          email={details?.email}
          setEmail={updateEmail}
          setEmailValid={setEmailValid}
        />
        <Password
          password={details?.password}
          setPassword={updatePassword}
          setPasswordError={setPasswordError}
        />
      </div>

      {localError && <p className=" text-sm text-primary_700">{localError}</p>}
      {error && <p className=" text-sm text-primary_700">{error}</p>}
      <div className="flex gap-4 flex-col w-full">
        <ButtonWithoutIcon
          text={loading ? "loading..." : "Sign Up"}
          onButtonClick={signInClick}
          classNames={`${loading || !details?.email || !isEmailValid || !details?.password || details?.password?.length < MINIMUM_PASSWORD_LENGTH ? "cursor-not-allowed opacity-60" : "cursor-pointer"} text-white p-4`}
        />
        {/* <OrBetweenButtons />
                <button
                    className='w-full p-4  rounded-full outline-none border-[0.08rem] border-inputbox-border-color flex items-center gap-2 justify-center'
                    onClick={() => signUpWithGoogle()}
                    style={{
                        "boxShadow": "0px 2px 2px 0px rgba(0, 0, 0, 0.08)",
                    }}>

                    <img src={googleIcon} alt="googleIcon" />
                    <span>Sign up with google</span>
                </button> */}
      </div>

      <div className=" mt-6">
        <p className=" text-gray-400">
          Already have an account ?{" "}
          <span
            className="text-primary-color-900  font-semibold cursor-pointer"
            onClick={() => Navigate("/auth/login")}
          >
            Log in{" "}
          </span>{" "}
        </p>
        {/* <p className='pt-1 text-gray-400 text-xs'>By continuing, you agree to Termns of Use and Privacy Policy  </p> */}
      </div>
    </>
  );
};

export default RegistorMain;
